import React from 'react';

const Circle = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="3" height="3" viewBox="0 0 3 3" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="1.5" cy="1.5" r="1.5" fill="currentColor" />
    </svg>
  );
};

export default Circle;
